import { render, staticRenderFns } from "./OpeningHoursDisplay.vue?vue&type=template&id=0836405b&"
import script from "./OpeningHoursDisplay.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports